<ion-card [class.mobile-card]="platform === platformRef.mobile">
  <ion-row
    data-cy="ingredient-card"
    class="ingredient-card"
    [ngClass]="
      platform !== platformRef.desktop
        ? platform === platformRef.tablet
          ? 'tablet'
          : 'mobile'
        : 'desktop'
    "
    (click)="stopClickThrough($event)"
  >
    <ng-container
      *ngIf="platform === platformRef.desktop"
      [ngTemplateOutlet]="desktopColumns"
    ></ng-container>
    <ng-container
      *ngIf="platform === platformRef.tablet"
      [ngTemplateOutlet]="tabletColumns"
    ></ng-container>
    <ng-container
      *ngIf="platform === platformRef.mobile"
      [ngTemplateOutlet]="mobileColumns"
    ></ng-container>
  </ion-row>
</ion-card>

<ng-template #mobileColumns>
  <ion-col class="num" [size]="1.15" offset="0.05">
    <ng-container [ngTemplateOutlet]="number"></ng-container
  ></ion-col>
  <ion-col [size]="3.5" [offset]="0.25">
    <ng-container [ngTemplateOutlet]="nameAndType"></ng-container
  ></ion-col>
  <ion-col [size]="2" [offset]="0.5">
    <ng-container [ngTemplateOutlet]="quantityUOM"></ng-container
  ></ion-col>
  <ion-col class="cost" [size]="2" [offset]="0.5">
    <ng-container [ngTemplateOutlet]="cost"></ng-container
  ></ion-col>
  <ion-col class="info-icon" [size]="0.25" [offset]="0.25">
    <ng-container
      *ngIf="shouldShowZeroCostIcon()"
      [ngTemplateOutlet]="infoPopover"
    ></ng-container>
  </ion-col>
  <ion-col [class.mobile]="ellipsis" [size]="0.5">
    <ng-container [ngTemplateOutlet]="ellipsis"></ng-container>
  </ion-col>
</ng-template>

<ng-template #desktopColumns>
  <!-- <ion-col class="thumb" [size]="0.5">
    <ng-container [ngTemplateOutlet]="thumb"></ng-container>
  </ion-col> -->
  <ion-col class="num" [size]="0.5" [offset]="0.1388">
    <ng-container [ngTemplateOutlet]="number"></ng-container
  ></ion-col>
  <ion-col
    class="item"
    [size]="containerSize > 11 ? 2.5 : 4.5"
    [offset]="0.1288"
  >
    <ng-container [ngTemplateOutlet]="itemName"></ng-container
  ></ion-col>
  <ion-col
    class="quantity"
    [size]="containerSize > 11 ? 0.75 : 1"
    [offset]="containerSize > 11 ? 0.1388 : 0.6388"
  >
    <ng-container [ngTemplateOutlet]="quantity"></ng-container
  ></ion-col>
  <ion-col
    class="uom"
    [size]="containerSize > 11 ? 1 : 2"
    [offset]="containerSize > 11 ? 0.1388 : 0.6388"
  >
    <ng-container [ngTemplateOutlet]="unitOfMeasure"></ng-container
  ></ion-col>
  <ion-col class="type" [size]="1" [offset]="0.1388" *ngIf="containerSize > 11">
    <ng-container [ngTemplateOutlet]="type"></ng-container
  ></ion-col>
  <ion-col
    class="brand"
    [size]="1"
    [offset]="0.1388"
    *ngIf="containerSize > 11"
  >
    <ng-container [ngTemplateOutlet]="brand"></ng-container
  ></ion-col>
  <ion-col class="cost" [size]="1" [offset]="0.1388" *ngIf="containerSize > 11">
    <ng-container [ngTemplateOutlet]="cost"></ng-container
  ></ion-col>
  <ion-col class="note" [size]="2" [offset]="0.1388" *ngIf="containerSize > 11">
    <ng-container [ngTemplateOutlet]="note"></ng-container
  ></ion-col>
  <ion-col
    *ngIf="shouldShowZeroCostIcon()"
    class="info-icon"
    [size]="0.25"
    [offset]="containerSize > 11 ? 0.25 : 0.5"
  >
    <ng-container [ngTemplateOutlet]="infoPopover"></ng-container>
  </ion-col>
  <ion-col class="ellipsis" [size]="0.5">
    <ng-container [ngTemplateOutlet]="ellipsis"></ng-container>
  </ion-col>
</ng-template>

<ng-template #tabletColumns>
  <!-- <ion-col class="thumb" [size]="1">
    <ng-container
    [ngTemplateOutlet]="thumb"
  ></ng-container>
  </ion-col> -->
  <ion-col class="num" [size]="0.5" [offset]="0.25">
    <ng-container [ngTemplateOutlet]="number"></ng-container>
  </ion-col>
  <ion-col class="item" [size]="6" [offset]="0.125">
    <ng-container [ngTemplateOutlet]="itemName"></ng-container>
  </ion-col>
  <ion-col class="quantity" [size]="0.5" [offset]="0.5">
    <ng-container [ngTemplateOutlet]="quantity"></ng-container>
  </ion-col>
  <ion-col class="uom" [size]="2" [offset]="0.5">
    <ng-container [ngTemplateOutlet]="unitOfMeasure"></ng-container>
  </ion-col>
  <ion-col
    *ngIf="shouldShowZeroCostIcon()"
    class="info-icon"
    [size]="0.25"
    [offset]="0.125"
  >
    <ng-container [ngTemplateOutlet]="infoPopover"></ng-container>
  </ion-col>
  <ion-col class="ellipsis" [size]="0.75">
    <ng-container [ngTemplateOutlet]="ellipsis"></ng-container>
  </ion-col>
</ng-template>

<ng-template #thumb>
  <ion-icon name="reorder-three-outline"></ion-icon>
</ng-template>

<ng-template #number>
  <p [class.mobile]="platform === platformRef.mobile">
    {{ cardData.displayIndex }}
  </p>
</ng-template>

<ng-template #infoPopover>
  <ion-icon
    data-cy="cost-information-icon"
    color="danger"
    name="information-circle"
    (click)="presentZeroCostPopover($event)"
    (mouseover)="
      platform === platformRef.desktop
        ? presentZeroCostPopover($event)
        : undefined
    "
    (mouseout)="platform === platformRef.desktop ? dismiss() : undefined"
  ></ion-icon>
</ng-template>

<ng-template #itemName>
  <p
    class="bold"
    (click)="onNameClick($event)"
    [class.click]="cardData.type !== typeRef.RECIPE"
  >
    {{
      !!cardData.itemName
        ? cardData.itemName
        : ('i18n.menuProfitPro.ingredient.name' | translate | acronymTitleCase)
    }}
  </p>
</ng-template>

<ng-template #nameAndType>
  <div class="name-and-type" (click)="onNameClick($event)">
    <p
      class="name shorten mobile left"
      [class.click]="cardData.type !== typeRef.RECIPE"
    >
      {{
        cardData.itemName ?? ('i18n.menuProfitPro.ingredient.name' | translate)
          | acronymTitleCase
      }}
    </p>
    <p class="capitalize shorten">
      {{ cardData.readableType }}
    </p>
  </div>
</ng-template>

<ng-template #quantity>
  <ion-input
    [value]="cardData.quantity"
    [placeholder]="'#'"
    class="numeric"
    customDecimal
    [maxLeftHandDigits]="4"
    [maxPrecision]="2"
    (ionBlur)="onQuantityInputBlur($event)"
    (click)="stopClickThrough($event)"
  ></ion-input>
</ng-template>

<ng-template #unitOfMeasure>
  <ion-item
    id="ingredient-serv-uom"
    data-cy="ingredient-serv-uom-button"
    detail="true"
    detail-icon="chevron-down-outline"
    globalkeyhandler="input"
    [class.tablet]="platform === platformRef.tablet"
    (click)="onUomDropdownClick($event)"
  >
    <ion-label [class.gray]="!cardData.quantityUom">
      {{
        !!cardData.quantityUom
          ? (getTranslatedUOM(cardData.quantityUom) | translate)
          : ('i18n.menuProfitPro.ingredient.uOfM' | translate)
      }}
    </ion-label>
  </ion-item>
</ng-template>

<ng-template #quantityUOM>
  <p class="mobile">
    {{
      cardData.quantity +
        ' ' +
        (!!cardData.quantityUom
          ? cardData.quantityUom
          : ('i18n.menuProfitPro.ingredient.uOfM' | translate))
    }}
  </p>
</ng-template>

<ng-template #type>
  <p class="capitalize">
    {{ cardData.readableType }}
  </p>
</ng-template>

<ng-template #brand>
  <p class="capitalize">
    {{ cardData.brand }}
  </p>
</ng-template>

<ng-template #cost>
  <p
    [class.gray]="cardData.cost === 0 || cardData.cost === null"
    class="currency"
    [class.mobile]="platform === platformRef.mobile"
  >
    {{ cardData.cost | currency }}
  </p>
</ng-template>
<ng-template #note>
  <ion-input
    [(ngModel)]="cardData.note"
    (ngModelChange)="onNoteChange($event)"
    (ionBlur)="onNoteInputBlur($event)"
    [placeholder]="'i18n.menuProfitPro.ingredient.note' | translate"
    class="normal"
    [class.error]="!!noteContainsEmojis"
    [maxlength]="30"
    (click)="stopClickThrough($event)"
  ></ion-input>
</ng-template>

<ng-template #ellipsis>
  <div
    [attr.data-cy]="'ingredient-card-ellipsis-section' + cardData.index"
    class="ellipsis"
    id="{{ cardData.index }}"
    (click)="onEllipsisClick($event)"
  >
    <ion-icon
      class="ellipsis-icon"
      name="ellipsis-vertical"
      [class.mobile]="platform === platformRef.mobile"
    ></ion-icon>
  </div>
</ng-template>
